import type { FunctionComponent } from 'react';
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { ROSTER_ROUTES, ROUTES } from '../../../util/vars';
import NavLink from './Nav.styled';
import { useCleverIntegration } from '../../../hooks/useCleverIntegration';

const Nav: FunctionComponent = () => {
  const { translate } = useI18n();
  const [ isClever ] = useCleverIntegration();

  return (
    <div className={'flex items-center justify-evenly bg-white shadow py-4'}>
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.student}`}
        icon={'StudentChart'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.STUDENTS')}
        size={80}
        data-cy={'rm-nav-students'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.staff}`}
        icon={'Student'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.STAFF')}
        data-cy={'rm-nav-staff'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.class}`}
        icon={'Classes'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.CLASSES')}
        data-cy={'rm-nav-classes'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.tags}`}
        icon={'Label'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.TAGS')}
        data-cy={'rm-nav-tags'}
      />
      <NavLink
        to={`${ROUTES.roster_management}${ROSTER_ROUTES.upload}`}
        icon={'CloudUpload'}
        label={translate('pages.ROSTER_MANAGEMENT.NAV.UPLOAD')}
        data-cy={'rm-nav-upload'}
        disabled={isClever}
      />
    </div>
  );
};

export default Nav;
